import { Injectable } from '@angular/core';
import { Ng2ImgMaxService } from 'ng2-img-max';
import 'rxjs/add/operator/toPromise';


@Injectable()
export class ImageResizer {
    ng2ImgMaxService:Ng2ImgMaxService;

    constructor(ng2ImgMaxService:Ng2ImgMaxService) {
        this.ng2ImgMaxService = ng2ImgMaxService;
    }

    async resize(imageUrl):Promise<string> {
        // NOTE: If toPromise doesnt resolve, the underlying stream may not be onComplete-ing.
        //       Use take(1) to fix.
        //       See https://github.com/Reactive-Extensions/RxJS/issues/1088
        var originalBlob;
        if (imageUrl.startsWith('data:')) {
            originalBlob = this.dataURItoBlob(imageUrl);
        } else {
            originalBlob = await this.downloadUrlAsBlob(imageUrl);
        }
        var blob:Blob = await this.ng2ImgMaxService.resizeImage(<File>originalBlob, 2000, 1000).take(1).toPromise();
        
        return this.blobToDataURI(blob);
    }

    async downloadUrlAsBlob(url:string) {
        return new Promise((resolve, reject) => {
            var r = new XMLHttpRequest();
            r.open("GET", url);
            r.responseType = "arraybuffer";
            r.onload = function() {
                resolve(new Blob([this.response], {type: this.getResponseHeader('content-type')}));
            }
            r.send();
        })
    }

    dataURItoBlob = (dataURI:string):Blob => {
        var byteString = atob(dataURI.split(',')[1]);
    
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
    
        return new Blob([ab], {type: mimeString});
    }

    blobToDataURI = (blob:Blob):Promise<string> => {
        return new Promise((resolve, reject) => {
            var a = new FileReader();
            a.onload = function(e) {
                resolve(a.result);
            }
            a.readAsDataURL(blob);
        });
    }
}


// WEBPACK FOOTER //
// ./web/static/services/ImageResizer.ts